<div class="loading-container">
  <img src="../../../assets/gif/loading.gif" alt="Loading..." />
  </div>